import { useMemo, useState } from 'react';
import { BillsContext } from './BillsContext';
import { IBillContext, ClaimsTypeTypes, IBill, BillClaimsSelectedType } from '../../models/Bills.interfaces';
import { AxiosError } from 'axios';

const BillsProvider = ({ children }: { children: React.ReactNode }) => {
    const [bills, setBills] = useState<IBill[]>([]);
    const [billsToDownload, setBillsToDownload] = useState<Set<string>>(new Set());
    const [isDownloadCompleted, setIsDownloadCompleted] = useState(false);
    const [billsDownloaded, setBillsDownloaded] = useState<string[]>([]);
    const [billsWithError, setBillsWithError] = useState<string[]>([]);
    const [downloadError, setDownloadError] = useState<AxiosError | null>(null);
    const [billsZip, setBillsZip] = useState<Blob | null>(null);
    const [claimType, setClaimsType] = useState<ClaimsTypeTypes>('');
    const [bill, setBill] = useState<IBillContext>({
        id: '',
        amount: 0,
        issueDate: '',
        legalEntity: '',
        debt: null,
    });
    const [billClaimsSelected, setBillClaimsSelected] = useState<Set<string>>(new Set());
    const [claims, setClaims] = useState<BillClaimsSelectedType[]>([]);
    const [claimId, setClaimId] = useState('');
    const [claimComment, setClaimComment] = useState('');
    const [customerAccount, setCustomerAccount] = useState('');

    const resetClaimValues = () => {
        setClaimsType('');
        setClaims([]);
        setBillClaimsSelected(new Set());
    };

    const value = useMemo(
        () => ({
            bills,
            billsToDownload,
            isDownloadCompleted,
            billsDownloaded,
            billsWithError,
            downloadError,
            billsZip,
            claimType,
            bill,
            billClaimsSelected,
            claims,
            claimId,
            claimComment,
            customerAccount,
            setBills,
            setBillsToDownload,
            setIsDownloadCompleted,
            setBillsDownloaded,
            setBillsWithError,
            setDownloadError,
            setBillsZip,
            setClaimsType,
            resetClaimValues,
            setBill,
            setBillClaimsSelected,
            setClaims,
            setClaimId,
            setClaimComment,
            setCustomerAccount,
        }),
        [
            bills,
            billsToDownload,
            isDownloadCompleted,
            billsDownloaded,
            billsWithError,
            downloadError,
            billsZip,
            claimType,
            billClaimsSelected,
            claims,
            bill,
            claimId,
            claimComment,
            customerAccount,
        ],
    );

    return <BillsContext.Provider value={value}>{children}</BillsContext.Provider>;
};

export default BillsProvider;
